import api from './api'

export default {
  /**
   * Busca todas as configurações de score
   */
  async buscarTodas() {
    return await api.get('/configuracoes')
  },

  /**
   * Busca configurações como objeto chave-valor
   */
  async buscarComoObjeto() {
    return await api.get('/configuracoes/objeto')
  },

  /**
   * Atualiza configurações
   */
  async atualizar(configuracoes) {
    return await api.post('/configuracoes', { configuracoes })
  },

  /**
   * Busca o contexto da IA
   */
  async buscarContextoIA() {
    return await api.get('/configuracoes/contexto-ia')
  },

  /**
   * Atualiza o contexto da IA
   */
  async atualizarContextoIA(contexto) {
    return await api.post('/configuracoes/contexto-ia', { contexto })
  }
}

